import React from 'react';

const statusColors = {
  // Lead status
  Hot: 'bg-red-100 text-red-700',
  Warm: 'bg-orange-100 text-orange-700',
  Cold: 'bg-blue-100 text-blue-700',
  // Delivery
  Terkirim: 'bg-green-100 text-green-700',
  Proses: 'bg-yellow-100 text-yellow-700',
  // Team status
  active: 'bg-green-100 text-green-700',
  inactive: 'bg-gray-100 text-gray-500',
  leave: 'bg-purple-100 text-purple-700',
  // SPK
  Selesai: 'bg-green-100 text-green-700',
  Batal: 'bg-red-100 text-red-700',
  // Payment
  Cash: 'bg-teal-100 text-teal-700',
  Kredit: 'bg-indigo-100 text-indigo-700',
  // Lead source
  'Walk-in': 'bg-pink-100 text-pink-700',
  Referral: 'bg-violet-100 text-violet-700',
  Instagram: 'bg-rose-100 text-rose-700',
  Facebook: 'bg-blue-100 text-blue-700',
};

const statusLabels = {
  active: 'Aktif',
  inactive: 'Nonaktif',
  leave: 'Cuti',
};

export default function Badge({ status, className = '' }) {
  const colorClass = statusColors[status] || 'bg-gray-100 text-gray-600';
  const label = statusLabels[status] || status;
  return (
    <span className={`badge ${colorClass} ${className}`}>{label}</span>
  );
}

export function StatusDot({ status }) {
  const dotColors = {
    Hot: 'bg-red-500',
    Warm: 'bg-orange-500',
    Cold: 'bg-blue-500',
    Terkirim: 'bg-green-500',
    Proses: 'bg-yellow-500',
    active: 'bg-green-500',
    inactive: 'bg-gray-400',
    leave: 'bg-purple-500',
  };
  return <span className={`inline-block w-2 h-2 rounded-full ${dotColors[status] || 'bg-gray-400'}`} />;
}
